function getUserAgent(): string {
  return navigator.userAgent || navigator.vendor;
}

function getPlatform(): string {
  return navigator.platform;
}

export function isiOSDevice(): boolean {
  return (
    [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod',
    ].includes(getPlatform()) ||
    // iPad on iOS 13 detection
    (getUserAgent().includes('Mac') && 'ontouchend' in document)
  );
}

export function isMacDevice(): boolean {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (
    /Mac/i.test(getUserAgent()) && !isiOSDevice() && !(window as any).MSStream
  );
}

export function isMacOrIosDevice(): boolean {
  return isMacDevice() || isiOSDevice();
}
